import { useNavigate } from 'react-router-dom';
import { Button } from '@safetyhub/ui';
import { useModalStore } from '../stores/modal';
import CreateOrganizationModal from '../components/modals/CreateOrganizationModal';

/**
 * 온보딩 페이지
 *
 * 신규 가입자가 멤버십(조직)이 없을 때 표시됩니다.
 * 개인 작업공간 자동생성이 제거된 H-9c 이후, 조직 생성을 유도하는 CTA를 제공합니다.
 */
export default function Onboarding() {
  const navigate = useNavigate();
  const { openCreateOrganization } = useModalStore();

  const handleCreateOrganization = () => {
    // CreateOrganizationModal 열기 — WORKSPACE 카테고리 포함하여 생성 가능
    openCreateOrganization();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-50 px-4">
      <div className="max-w-md w-full text-center">
        {/* 아이콘 */}
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-brand-100">
          <svg
            className="h-10 w-10 text-brand-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
            />
          </svg>
        </div>

        {/* 제목 */}
        <h1 className="text-2xl font-bold text-ink-900 mb-3">아직 조직이 없습니다</h1>

        {/* 설명 */}
        <p className="text-ink-500 mb-8 leading-relaxed">
          SafetyHub를 시작하려면 작업 공간 또는 조직을 먼저 만들어야 합니다.
          <br />
          개인 작업 공간을 만들거나 팀 조직을 생성하세요.
        </p>

        {/* CTA 버튼 */}
        <Button
          type="button"
          variant="primary"
          size="lg"
          onClick={handleCreateOrganization}
          className="w-full"
        >
          <svg
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          작업 공간 / 조직 만들기
        </Button>

        {/* 초대 링크 안내 */}
        <p className="mt-4 text-sm text-ink-400">
          이미 조직에 초대받으셨나요?{' '}
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="text-brand-600 hover:underline font-medium"
          >
            초대 링크를 확인하세요
          </button>
        </p>
      </div>

      {/* 조직 생성 모달 — Layout 밖 온보딩 화면에서도 사용 */}
      <CreateOrganizationModal />
    </div>
  );
}
